import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/App";
import "@/lib/i18n";
import "@/index.css";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root-Element #root nicht gefunden — index.html prüfen");
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
